import React from 'react';
import { Alert, Box, Button, Divider, Typography } from '@mui/material';
import AutoFixNormalIcon from '@mui/icons-material/AutoFixNormal';
import { useWorkspace } from '../WorkspaceContext.js';
import { ACTION_META, ACTION_TYPES } from '../workspaceConstants.js';

const ActionsPanel = () => {
  const {
    activeScenario,
    actions,
    interactionMode,
    startDrawing,
    startErasing,
    cancelInteraction,
    pendingActionDeletions,
    confirmActionDeletion,
    undoActionDeletion,
    setOpenMenu,
  } = useWorkspace();

  if (!activeScenario) {
    return (
      <Alert severity="info" action={
        <Button color="inherit" size="small" onClick={() => setOpenMenu('scenarios')}>
          Zu den Szenarios
        </Button>
      }>
        Maßnahmen gehören zu einem Szenario. Aktivieren Sie zuerst ein Szenario.
      </Alert>
    );
  }

  const drawingType = interactionMode && interactionMode.startsWith('draw-')
    ? interactionMode.slice('draw-'.length)
    : null;
  const erasing = interactionMode === 'erase-actions';
  const totalCount = ACTION_TYPES.reduce((sum, type) => sum + actions[type].length, 0);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      <Typography variant="body2" color="text.secondary">
        Maßnahmen des Szenarios „{activeScenario.name}" ({totalCount}).
      </Typography>

      {!erasing && ACTION_TYPES.map((type) => {
        const meta = ACTION_META[type];
        const isActive = drawingType === type;
        return (
          <Button
            key={type}
            variant={isActive ? 'outlined' : 'contained'}
            disabled={Boolean(drawingType) && !isActive}
            sx={isActive ? undefined : { backgroundColor: meta.color, '&:hover': { backgroundColor: meta.color, filter: 'brightness(0.9)' } }}
            onClick={() => (isActive ? cancelInteraction() : startDrawing(type))}
          >
            {isActive ? 'Zeichnen beenden' : `${meta.label} einzeichnen`}
          </Button>
        );
      })}

      {drawingType && (
        <Alert severity="info">
          {ACTION_META[drawingType].label} auf der Karte einzeichnen –{' '}
          {ACTION_META[drawingType].geometry === 'polygon'
            ? 'zum Beenden den ersten Punkt erneut anklicken.'
            : 'zum Beenden doppelklicken.'}
        </Alert>
      )}

      {!drawingType && !erasing && (
        <>
          <Divider sx={{ my: 0.5 }} />
          <Alert severity="info" sx={{ py: 0 }}>
            Klicken Sie eine Maßnahme auf der Karte an, um ihre Eigenschaften zu bearbeiten.
          </Alert>
          <Button
            variant="contained"
            color="error"
            startIcon={<AutoFixNormalIcon />}
            onClick={() => startErasing('actions')}
            disabled={totalCount === 0}
          >
            Maßnahmen löschen
          </Button>
        </>
      )}

      {erasing && (
        <>
          <Alert severity="warning">
            Klicken Sie die Maßnahmen an, die Sie löschen möchten. Sie werden erst aus der Datenbank
            entfernt, wenn Sie das Löschen bestätigen.
          </Alert>
          <Typography variant="body2">
            {pendingActionDeletions.length === 1
              ? '1 Maßnahme zum Löschen markiert.'
              : `${pendingActionDeletions.length} Maßnahmen zum Löschen markiert.`}
          </Typography>
          <Button
            variant="contained"
            color="error"
            disabled={pendingActionDeletions.length === 0}
            onClick={confirmActionDeletion}
          >
            Löschen bestätigen
          </Button>
          <Button variant="outlined" color="inherit" onClick={undoActionDeletion}>
            Löschen rückgängig
          </Button>
        </>
      )}
    </Box>
  );
};

export default ActionsPanel;
